import React from 'react'
import { Trans } from '@lingui/react'
import LoadingIndicator from './LoadingIndicator.js'

const SubmitPage = () => (
  <LoadingIndicator>
    <Trans>Submitting your answers...</Trans>
  </LoadingIndicator>
)

export default SubmitPage



// WEBPACK FOOTER //
// ./src/components/SubmitPage.js